<template>
    <v-flex>
        <v-dialog v-model="modal_event_reg" persistent content-class="scrolled-dialog">
            <!-- @click.native="open('user_info')" -->

            <modalRegEvent v-if="modal_event_reg" :current_item_news='current_item_news' />
        </v-dialog>

        <div class="news__descr-left-img mb-5" :style="{backgroundImage: 'url('+current_item_news.image+')'}">
        </div>
        <!-- <v-layout class="news_dates mobile" justify-space-between>
            <v-flex><iconLabel icon_name="heart" class=" icon-label-red" size="20">{{ current_item_news.likes }}</iconLabel></v-flex>
            <v-flex><iconLabel icon_name="favorites" class="ml-4 icon-label-red" size="20">{{$t("В избранное")}}</iconLabel></v-flex>
        </v-layout> -->

        <div class="news__descr-left-decscr">
            <div v-if="date_from" class="news__descr-left-row">
                <div class="news__descr-left__tytle">{{$t("Время проведения")}}</div>
                <div class="news__descr-left__dates">{{ date_from }}  {{ time_from }} - {{ date_to }}  {{ time_to }}</div>
            </div>
            <div class="news__descr-left-row">
                <div class="news__descr-left__tytle">{{$t("Место проведения")}}</div>
                <div class="news__descr-left__value">
                    {{ current_item_news.place_event }}
                </div>
            </div>
            <div class="news__descr-left-row">
                <div class="news__descr-left__tytle">{{$t("Тип мероприятия")}}</div>
                <div class="news__descr-left__value">
                    {{ current_item_news.label }}
                </div>
            </div>
            <div class="news__descr-left-row">
                <div class="news__descr-left__tytle">{{$t("Участие")}}</div>
                <div class="news__descr-left__value">
                    {{ approval_required }}
                </div>
            </div>
            <div v-if="current_item_news.approval_required" class="news__descr-left__submit">
                <btn-red :disabled='news_content.registered' @click.native="check_click()">{{$t("Зарегистрироваться")}}</btn-red>
                <div v-if='news_content.registered' class="news__descr-left__tytle"> {{$t("Вы уже зарегистрированы")}}</div>
            </div>
        </div>
    </v-flex>
</template>
<script>
import {button_red} from '@/components/ui/buttons/base_buttons.js';
import labelTopic from '@/components/ui/labels/label_topic';
import iconLabel from '@/components/ui/icons/icon_with_label';
import modalRegEvent from './News_modals/news_modal_event_reg';
import {mapGetters, mapMutations, mapActions} from 'vuex';
import dayjs from 'dayjs';

export default {
  components: {
    'BtnRed': button_red,
    labelTopic,
    modalRegEvent,
    iconLabel,
  },
  props: {
    current_item_news: {
      type: Object,
    },
  },
  data() {
    return {
      error: false,
    };
  },

  computed: {
    ...mapGetters('news_main/detail', ['modal_event_reg', 'news_content']),
    date_from() {
      if (typeof this.current_item_news.date == 'object') {
        return new dayjs( this.current_item_news.date[0]).format('DD.MM.YYYY');
      } else {
        return this.current_item_news.date_from;
      }
    },
    date_to() {
      if (typeof this.current_item_news.date == 'object') {
        return new dayjs( this.current_item_news.date[1]).format('DD.MM.YYYY');
      } else {
        return this.current_item_news.date_to;
      }
    },
    time_to() {
      if (typeof this.current_item_news.date == 'object') {
        return new dayjs( this.current_item_news.date[1]).format('HH.mm');
      } else {
        return this.current_item_news.time_to;
      }
    },
    time_from() {
      if (typeof this.current_item_news.date == 'object') {
        return new dayjs( this.current_item_news.date[0]).format('HH.mm');
      } else {
        return this.current_item_news.time_from;
      }
    },
    image: {
      get() {
        return this.current_item_news.image;
      },
    },
    approval_required: {
      get() {
        if (this.current_item_news.approval_required) {
          return 'С регистрацией';
        } else {
          return 'Без регистрации';
        }
      },
    },
  },
  methods: {
    check_click() {
      if (!this.news_content.registered) {
        this.SET_NEWS_CONTENT_REGISTERED();
        this.register_event();
      }
    },
    ...mapActions('registration_event', ['register_event']),
    ...mapMutations('news_main/detail', ['OPEN_MODAL', 'CLOSE_MODAL', 'SET_NEWS_CONTENT_REGISTERED']),
    // ...mapMutations('registration_event', ['SET_REGISTRATION_ID']),
    // register() {
    //   try {
    //     this.register_event();
    //     this.error = false;
    //   } catch (err) {
    //     this.error = true;
    //   }
    // },
    // close_modal() {
    //   this.CLOSE_MODAL('modal_event_reg');
    // },
  },
};
</script>

